module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-4db89bb20af18259dad40ce76de8de83.png";